import { siteInfo, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-secondary-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {col.title}
              </h4>
              {col.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => handleClick(e, link.href)}
                        className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-400">虚位以待</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-200 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-sm"></i>
              </span>
              <span className="text-base font-bold text-foreground-900 font-heading whitespace-nowrap">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-xs text-foreground-400 leading-relaxed text-center sm:text-left">
              久播影院提供最新电视剧全集免费在线观看不缓冲，高清国产剧韩剧全集一网打尽。每日更新，秒开不缓冲。
            </p>
            <p className="text-xs text-foreground-400 whitespace-nowrap">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}